import React from "react";

// ui importing
import HomeUI from "../../../../ui/homeUI/_index";

const TaskNewRPage = () => {
  return (
    <>
      <HomeUI />
    </>
  )
}

export default TaskNewRPage;

